import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import jwtService from 'app/services/jwtService';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { hideMessage, showMessage } from 'app/store/fuse/messageSlice';

import { setUserData, logoutUser } from './store/userSlice';

class Auth extends Component {
  state = {
    waitAuthCheck: true
  };

  componentDidMount() {
    return Promise.all([this.jwtCheck()]).then(() => {
      this.setState({ waitAuthCheck: false });
    });
  }

  jwtCheck = () =>
    new Promise(async resolve => {
      // 👇 Detectamos si volvemos desde Encompass
      const redirected = await checkForEncompassRedirect(this.props.dispatch);
      if (redirected) {
        return resolve();
      }

      jwtService.on('onAutoLogin', () => {
        localStorage.removeItem('user');
        jwtService
          .signInWithToken()
          .then(user => {
            this.props.setUserData(user);
            resolve();
          })
          .catch(error => {
            this.props.showMessage({ message: error.message });
            resolve();
          });
      });

      jwtService.on('onAutoLogout', message => {
        if (message) {
          this.props.showMessage({ message });
        }
        jwtService.setSession(null);
        localStorage.removeItem('user');
        this.props.logout();
        resolve();
      });

      jwtService.on('onNoAccessToken', () => resolve());
      jwtService.on('onUnauthorizedUser', message => {
        if (message) this.props.showMessage({ message });
        resolve();
      });
      jwtService.on('onServerError', message => {
        if (message) this.props.showMessage({ message });
        resolve();
      });

      jwtService.init();
    });

  render() {
    return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
  }
}

// ✅ Función para detectar redirección desde Encompass
function checkForEncompassRedirect() {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

  if (code) {
    // const redirectUri = window.location.origin + window.location.pathname;
    
    // sessionStorage.removeItem('jwt_access_token');

    // import('./store/loginSlice').then(({ submitEncompassToken }) => {
    //   dispatch(submitEncompassToken({ authorizationCode: code, redirectUri }));
    // });

    return true;
  }

  return false;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: logoutUser,
      setUserData,
      showMessage,
      hideMessage
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Auth);
